export default "__VITE_ASSET__Bx837BNt__"